/* eslint-disable */
import axiosInstance from "@/composables/axios-instance.js";
import { toast } from "vue3-toastify";
import router from "@/router";

const state = {
  jobsPosition: [],
  jobDetail: [],
  partsAndSections: [],
  cooperationTypes: [],
  requestJobRequirements: [],
  requestJobData: {},
  requestsList: [],
  allRequestsList: [],
  requestAndProfileDetail: [],
  resume: [],
};

const getters = {
  getJobsPosition(state) {
    return state.jobsPosition;
  },
  getJobDetail(state) {
    return state.jobDetail;
  },
  getPartsAndSections(state) {
    return state.partsAndSections;
  },
  getCooperationTypes(state) {
    return state.cooperationTypes;
  },
  getRequestJobRequirements(state) {
    return state.requestJobRequirements;
  },
  getRequestJobData(state) {
    return state.requestJobData;
  },
  getRequestsList(state) {
    return state.requestsList;
  },
  getAllRequestsList(state) {
    return state.allRequestsList;
  },
  getRequestAndProfileDetail(state) {
    return state.requestAndProfileDetail;
  },
  getResume(state){
    return state.resume;
  }
};

const mutations = {
  setJobsPosition(state, jobs) {
    state.jobsPosition = jobs;
  },
  setJobDetail(state, detail) {
    state.jobDetail = detail;
  },
  setPartsAndSections(state, data) {
    state.partsAndSections = data;
  },
  setCooperationTypes(state, types) {
    state.cooperationTypes = types;
  },
  setRequestJobRequirements(state, requirements) {
    state.requestJobRequirements = requirements;
  },
  setRequestJobData(state, requestJobData) {
    state.requestJobData = requestJobData;
  },
  setRequestsList(state, requests) {
    state.requestsList = requests;
  },
  setAllRequestsList(state, allRequests) {
    state.allRequestsList = allRequests;
  },
  setRequestAndProfileDetail(state, details) {
    state.requestAndProfileDetail = details;
  },
  setResume(state, resume){
    state.resume = resume;
  }
};

const actions = {

  getJobsPositionFromApi({ commit }) {
    return axiosInstance
      .get("/job/position/list/")
      .then(response => {
        commit("setJobsPosition", response.data);
      })
      .catch(error => {
        console.error(error);
        toast.error("مشکلی پیش آمده لطفا بعدا تلاش کنید");
      });
  },

  getJobDetailFromApi({ commit }, id) {
    return axiosInstance
      .get("/job/position/detail/" + id)
      .then(response => {
        commit("setJobDetail", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getPartsAndSectionsFromApi({ commit }) {
    return axiosInstance
      .get("/base/part-section/list/")
      .then(response => {
        commit("setPartsAndSections", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getCooperationTypesFromApi({ commit }, id) {
    return axiosInstance
      .get(`/job/position/${id}/cooperation_types/`)
      .then(response => {
        commit("setCooperationTypes", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getRequestJobRequirementsFromApi({ commit }) {
    return axiosInstance
      .get("/preferences/application/")
      .then(response => {
        commit("setRequestJobRequirements", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getRequestJobDataFromApi({ commit }, id) {
    return axiosInstance
      .get(`/job/application/${id}/detail/`)
      .then(response => {
        commit("setRequestJobData", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  createRequest({}, { data, id }) {
    return axiosInstance
      .post(`/job/application/create/${id}/`, data)
      .then(() => {
        router.push({
          name: "requests",
          query: {
            send: "success",
          },
        });
      })
      .catch(error => {
        console.error(error);
        
        if (error.response && error.response.status === 400 && error.response.data.detail) {
           toast.error("شما قبلاً برای این موقعیت شغلی درخواست داده‌اید. برای ویرایش به صفحه موقعیت‌های شغلی درخواستی بروید.");
        } else {
           toast.error("اطلاعات را به درستی وارد کنید");
        }
      });
  },

  changeRequestStatus({ }, { id, status }) {
    return axiosInstance
      .post(`/job/application/${id}/reviews/`, status)
      .then(() => {
        toast.success("تغییرات مورد نظر با موفقیت اعمال شد");
      })
      .catch(error => {
        console.error(error);
        toast.error(error.response.data.message);
      });
  },

  getRequestsListFromApi({ commit }) {
    return axiosInstance
      .get('/job/application/list/')
      .then(response => {
        commit("setRequestsList", response.data.reverse());
      })
      .catch(error => {
        console.error(error);
      });
  },

  // 🔹 UPDATED ACTION: Sends all properties inside the filter object dynamically to the backend
  getAllRequestsListFromApi({ commit }, filter) {
    return axiosInstance
      .get('/job/application/list/all/request', { 
        params: { 
          search: filter.search, 
          limit: filter.limit, 
          offset: filter.offset,
          statuses: filter.statuses,  // 👈 Added
          parts: filter.parts,        // 👈 Added
          sections: filter.sections   // 👈 Added
        } 
      })
      .then(response => {
        commit("setAllRequestsList", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getRequestAndProfileDetailFromApi({ commit }, id) {
    return axiosInstance
      .get(`/job/application/detail/${id}/`)
      .then(response => {
        commit("setRequestAndProfileDetail", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  deleteRequest({ dispatch }, id) {
    return axiosInstance
      .delete(`/job/application/${id}/delete/`)
      .then(async () => {
        await dispatch("getRequestsListFromApi");
        toast.success("درخواست با موفقیت کنسل شد");
      })
      .catch(error => {
        console.error(error);
      });
  },

  getResumeFromApi({ commit }, id){
    return axiosInstance
      .get(`/job/application/detail/${id}/`)
      .then(response => {
        commit("setResume", response.data);
      })
      .catch(error=>{
        console.error(error);
        toast.error("اطلاعات دریافت نشد، لطفا بعدا تلاش کنید.")
      })
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};